/**
 * DEMO MODE CONTROL - For Dashboard Owner
 *
 * Features:
 * - Toggle demo mode
 * - Generate mockup real-time data
 * - Reset demo data
 */

import React, { useState } from 'react';
import { Play, Trash2, Database, TrendingUp } from 'lucide-react';

const DemoModeControl = ({ api, user, onDataGenerated, onReset }) => {
  const [generating, setGenerating] = useState(false);
  const [resetting, setResetting] = useState(false);

  const generateMockupData = async () => {
    if (!confirm('Generate mockup data real-time untuk demo?\n\nIni akan membuat data simulasi 30 hari ke belakang.')) {
      return;
    }

    setGenerating(true);
    try {
      const response = await fetch(`${api}/laporan-shift/simulate-data`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${user.token}` }
      });

      const result = await response.json();
      alert(result.message || 'Mockup data berhasil dibuat!');
      if (onDataGenerated) onDataGenerated();
    } catch (error) {
      alert('Gagal generate mockup: ' + error.message);
    } finally {
      setGenerating(false);
    }
  };

  const resetAllData = async () => {
    if (!confirm('PERINGATAN: Ini akan menghapus SEMUA data laporan shift!\n\nTermasuk data mockup dan data asli.\n\nLanjutkan?')) {
      return;
    }

    if (!confirm('Apakah Anda YAKIN? Tindakan ini TIDAK DAPAT dibatalkan!')) {
      return;
    }

    setResetting(true);
    try {
      const response = await fetch(`${api}/laporan-shift/reset-all`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${user.token}` }
      });

      const result = await response.json();
      alert(result.message || 'Semua data berhasil direset!');
      if (onReset) onReset();
    } catch (error) {
      alert('Gagal reset: ' + error.message);
    } finally {
      setResetting(false);
    }
  };

  return (
    <div className="bg-gradient-to-r from-purple-50 to-pink-50 border-2 border-purple-200 rounded-lg p-4">
      <div className="flex items-center gap-2 mb-3">
        <Database className="text-purple-600" size={20} />
        <h3 className="font-bold text-purple-900">Demo Mode Controls</h3>
      </div>

      <p className="text-sm text-gray-600 mb-4">
        Generate data mockup untuk presentasi atau demo. Data akan terlihat real-time seperti data asli.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {/* Generate Mockup Data */}
        <button
          onClick={generateMockupData}
          disabled={generating}
          className="flex items-center justify-center gap-2 px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow"
        >
          <Play size={18} className={generating ? 'animate-pulse' : ''} />
          {generating ? 'Generating...' : 'Generate Mockup Data'}
        </button>

        {/* Reset All Data */}
        <button
          onClick={resetAllData}
          disabled={resetting}
          className="flex items-center justify-center gap-2 px-4 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow"
        >
          <Trash2 size={18} className={resetting ? 'animate-pulse' : ''} />
          {resetting ? 'Resetting...' : 'Reset Semua Data'}
        </button>
      </div>

      {/* Info */}
      <div className="mt-4 p-3 bg-white rounded border border-purple-200">
        <div className="flex items-start gap-2">
          <TrendingUp className="text-purple-600 mt-0.5" size={16} />
          <div className="text-xs text-gray-600">
            <p className="font-semibold text-purple-900 mb-1">Data Mockup:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>30 hari data transaksi simulasi</li>
              <li>3 loket dengan berbagai provider</li>
              <li>TUNAI & NON-TUNAI transactions</li>
              <li>Auto-calculate: omzet, laba rugi</li>
              <li>Real-time dashboard updates</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoModeControl;
